<template>
  <div class="card gateway-container">
    <div class="stack-lg">
      <div class="gateway-success-icon">
        <svg class="gateway-icon-svg" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
      </div>

      <div>
        <h2 class="gateway-title text-success">{{ t('paymentGateway.success') }}</h2>
        <p class="gateway-subtitle">{{ t('paymentGateway.subtitle') }}</p>
      </div>

      <div class="card bg-surface">
        <div class="flex-between gateway-detail-row">
          <span class="text-muted">{{ t('paymentGateway.plan') }}</span>
          <span class="font-bold">{{ planName }}</span>
        </div>
        <div v-if="store.currentQuote" class="flex-between gateway-detail-row">
          <span class="text-muted">{{ t('payment.total') }}</span>
          <span class="font-bold">&euro;{{ (store.currentQuote.total_cents / 100).toFixed(2) }}</span>
        </div>
        <div class="flex-between gateway-detail-row">
          <span class="text-muted">{{ t('paymentGateway.method') }}</span>
          <div class="flex-center gap-sm">
            <img v-if="paymentMethod === 'stripe'" :src="visaLogo" alt="Visa" class="selection-option-image" />
            <img v-if="paymentMethod === 'stripe'" :src="mastercardLogo" alt="Mastercard" class="selection-option-image" />
            <img v-if="paymentMethod === 'googlepay'" :src="googlePayLogo" alt="Google Pay" class="selection-option-image" />
            <img v-if="paymentMethod === 'applepay'" :src="applePayLogo" alt="Apple Pay" class="selection-option-image" />
          </div>
        </div>
      </div>

      <div class="gateway-progress-section">
        <p class="text-muted gateway-redirecting-text">{{ t('paymentGateway.redirecting') }}</p>
        <div class="gateway-progress-track">
          <div class="progress-bar-animated"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAppStore } from '@/stores/app';
import visaLogo from '@/assets/images/visa.png';
import mastercardLogo from '@/assets/images/mastercard.png';
import applePayLogo from '@/assets/images/apple-pay.png';
import googlePayLogo from '@/assets/images/google-pay.png';

const { t } = useI18n();
const store = useAppStore();

const paymentMethod = computed(() => store.paymentMethod);
const selectedPlan = computed(() => store.selectedPlan);

const planName = computed(() => {
  if (!selectedPlan.value) return '';
  const catalogMatch = store.catalog?.packages?.find((pkg) => pkg.name === selectedPlan.value);
  return catalogMatch?.label || selectedPlan.value;
});

onMounted(() => {
  if (!store.sessionId) {
    store.setError('Session data is missing. Please start over.');
    setTimeout(() => store.setStep('landing'), 3000);
    return;
  }
  // Auto-advance to report generation after showing confirmation
  setTimeout(() => store.setStep('generating'), 2000);
});
</script>

<style scoped>
.progress-bar-animated {
  height: 100%;
  width: 100%;
  background: rgb(var(--color-primary));
  border-radius: var(--radius-full);
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}
</style>
